import {
  ImportApi, ImportApiFp, ImportBody, // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedImportApi extends ImportApi {
  public importTrips (importBody: ImportBody, options?: any) {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return ImportApiFp(this.configuration).importTrips(importBody, null, options).then((request) => request(this.axios, this.basePath))
  }
}
